import { EFeatureType } from "../types/AdvanceFeature";
import { IUserFeature } from "../types/RoundRobin";

/**
 * Checks if the OTP verification feature is enabled.
 * @param features - The user features from time slot configuration.
 * @returns `true` if OTP is enabled, `false` otherwise.
 */
export const isOtpFeatureEnabled = (
  features: IUserFeature[] | undefined,
): boolean => {
  if (!features) {
    return false;
  }
  return features.some(
    (userFeature) =>
      userFeature?.featureType === EFeatureType.OtpVerification &&
      userFeature.enabled,
  );
};
